module.exports = __webpack_public_path__ + "static/media/iphone-mock.3a7e2c85.png";